import { useNavigate } from "react-router-dom";
import withLoader from "../../../../../components/layouts/WithLoader"
import { useEffect, useState } from "react";
import WorkstationService from "../../../../../services/Production/WorkstationService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import DataTableWorkOrdersByWorkStation from "../../../production/productionOrder/pages/DataTableWorkOrdersByWorkStation";

const WorkstationOperations =({startLoading, stopLoading})=>{


    const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
    const [dateEnd, setDateEnd] = useState("any");
    const [dateBegin, setDateBegin] = useState("any");
      const[availableOperations,setAvailableOperations]=useState();

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":59"));
  };


   const onGetWorkOrdersHandler=()=>{
     startLoading();
      WorkstationService.getWorkOrdersByWorkStation(getCurrentUserId(),sessionStorage.getItem("idWorkstation"), dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
          .then((response) => {
              console.log("response", response)
              if (response.data.success) {
                setAvailableOperations(response.data.success);
             } else {
               
              }
          })
          .catch((e) => {
              console.log("error in getAllRealWarehouse", e);
          }).finally(() => {
              stopLoading();
          });
  
    }

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":59"));
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
    useEffect(() => {
      startLoading();
      WorkstationService.getWorkOrdersByWorkStation(getCurrentUserId(),sessionStorage.getItem("idWorkstation"), dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
          .then((response) => {
              console.log("response", response)
              if (response.data.success) {
                setAvailableOperations(response.data.success);
             } else {
                  // setOpenErrorAlert(true);
                  // setErrorAlertText("Erreur : pas de station de travail");
              }
          })
          .catch((e) => {
              console.log("error in getAllRealWarehouse", e);
          }).finally(() => {
              stopLoading();
          });
  }, []);

  return(  <div className="content-wrapper" style={{ marginTop: "0" }}>
    <br/>
    <section className="content ">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <div class="card card-dark">
                    <div class="card-body">
                      <div class="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="inputName">Date début</label>
    
                            <TextField
                              style={{ width: "100%" }}
                              className="col-sm-12"
                              variant="outlined"
                              value={dateBegin}
                              onChange={onChangeDateBegin}
                              id="datetime-local"
                              type="datetime-local"
                              defaultValue="date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              size="small"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label htmlFor="inputName">Date fin</label>
    
                            <TextField
                              style={{ width: "100%" }}
                              className="col-sm-12"
                              variant="outlined"
                              value={dateEnd}
                              onChange={onChangeDateEnd}
                              id="datetime-local"
                              type="datetime-local"
                              defaultValue="date"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              size="small"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="col-sm-12  text-center">
                        <button
                          className="btn btn-dark"
                          onClick={onGetWorkOrdersHandler}
                        >
                          Valider le choix
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
       <section className="content ">
         <div className="container-fluid">
         <div className="row mb-2">
             <div className="col-sm-12">
         
               {availableOperations && (
                <DataTableWorkOrdersByWorkStation listWorkOrder={availableOperations} />
              )}
             </div>
           </div>
         </div>
       </section>
       <Snackbar
         open={openErrorAlert}
         autoHideDuration={2000}
         onClose={handleEroorClose}
         anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
       >
         <Alert variant="filled" onClose={handleEroorClose} severity="error">
           {errorAlertText}
         </Alert>
       </Snackbar>
     </div>)



}
export default withLoader(WorkstationOperations);